// Royal Natural v2 (Sense-base) — scroll reveal + sticky header shadow
(function () {
  document.addEventListener('scroll', function () {
    document.body.classList.toggle('rn-scrolled', window.scrollY > 10);
  }, { passive: true });
  var els = document.querySelectorAll('.shopify-section');
  els.forEach(function (el) { el.classList.add('rn-reveal'); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('rn-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('rn-visible'); });
  }
})();
